module.exports = __webpack_public_path__ + "media/static/icons/icon-point-e1a73fdf4f1e3f09d893a8dc8e5491cd.svg";